import React, { useState } from 'react';
import GlobalLayout from './GlobalLayout';
import EntityCombo from '../components/filters/EntityCombo';
import ComboLinker from '../components/filters/ComboLinker';

const TestCombo = () => {
    return (
        <GlobalLayout>
            <div style={{ padding: '1rem', margin: '0 auto', maxWidth: '1200px' }}>
                <h1>Test de EntityCombo</h1>
                <ComboLinker style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', alignItems: 'center' }}>
                    <EntityCombo
                        application="fvt"
                        category="filters"
                        source="entity"
                        name="region"
                        label="Régions"
                        type="region"
                        style={{ flex: '1 1 300px' }}
                    />

                    <EntityCombo
                        application="fvt"
                        category="filters"
                        source="entity"
                        name="departement"
                        label="Départements"
                        type="departement"
                        style={{ flex: '1 1 300px' }}
                    />

                    <EntityCombo
                        application="fvt"
                        category="filters"
                        source="entity"
                        name="commune"
                        label="Communes"
                        type="commune"
                        style={{ flex: '1 1 300px' }}
                    />
                </ComboLinker>
                <h1>Test de GroupCombo</h1>
                <ComboLinker style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', alignItems: 'center' }}>
                    <EntityCombo
                        application="airdna"
                        category="filters"
                        source="group"
                        name="observatoire"
                        label="Observatoire"
                        type="observatoire"
                        style={{ flex: '1 1 300px' }}
                    />
                    <EntityCombo
                        application="airdna"
                        category="filters"
                        source="group"
                        name="zone"
                        label="Zone"
                        type="zone"
                        style={{ flex: '1 1 300px' }}
                    />
                </ComboLinker>
            </div>
        </GlobalLayout>
    );
};

export default TestCombo;